import { useState } from 'react';
import { Download } from 'lucide-react';
import { UPDATE_TEXT, updateNow } from '../native/updates.js';

// "Update now": gets the newest version of the app's screens straight away
// instead of waiting for the next time the app is reopened.
// className styles the button (drawer link in the menu, a .btn on Support).
export default function UpdateButton({ className = 'btn with-icon', size = 18 }) {
  const [state, setState] = useState(null);
  const go = async () => {
    setState('checking');
    setState(await updateNow());
  };
  const busy = state === 'checking' || state === 'updating';
  return (
    <>
      <button type="button" className={className} onClick={go} disabled={busy}>
        <Download size={size} aria-hidden="true" className={busy ? 'spin' : ''} />
        <span>{busy ? UPDATE_TEXT[state] : 'Update now'}</span>
      </button>
      {state && !busy && <p className="small update-note" role="status">{UPDATE_TEXT[state]}</p>}
    </>
  );
}
